import script from "./WageDirectPay.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageDirectPay.vue?vue&type=script&setup=true&lang=ts"

import "./WageDirectPay.vue?vue&type=style&index=0&id=59f8ee76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f8ee76"]])

export default __exports__